"use client";

import { c as _c } from "react/compiler-runtime";
import { useSession } from "next-auth/react";
import React, { useEffect, useEffectEvent, useRef, useState } from "react";
import DatePickerElement from "@/app/(main)/(club)/mes-clubs/[id]/components/date-picker-element";
import { getAllDaysOfMonth } from "@/app/(main)/(club)/mes-clubs/[id]/utils/utils";
import { getClubEventsFromClient } from "@/app/api/dynabuy-back/client-side-api-events";
import { DatePickerProps, EventRead } from "@/TS/Interfaces/global_interfaces";
function DatePicker(t0) {
  const $ = _c(34);
  const {
    isHere,
    setIsHere,
    event,
    setValue,
    eventArr
  } = t0;
  let t1;
  if ($[0] !== event.startDate) {
    t1 = new Date(event.startDate);
    $[0] = event.startDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [date, setDate] = useState(t1);
  let t2;
  if ($[2] !== event.startDate) {
    t2 = new Date(event.startDate).getDate();
    $[2] = event.startDate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [currentDate, setCurrentDate] = useState(t2);
  let t3;
  if ($[4] !== eventArr) {
    t3 = eventArr.map(_temp);
    $[4] = eventArr;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [displayEventArr, setDisplayEventArr] = useState(t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const [, setEvents] = useState(t4);
  const [isLoading, setIsLoading] = useState(false);
  const {
    data: user
  } = useSession();
  const token = user?.user?.dynabuyToken;
  const abortControllerRef = useRef(null);
  let t5;
  if ($[7] !== date || $[8] !== event.clubSlug || $[9] !== event.startDate || $[10] !== setEvents || $[11] !== token) {
    t5 = async increment => {
      setCurrentDate(new Date(event.startDate).getDate());
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const newAbortController = new AbortController();
      abortControllerRef.current = newAbortController;
      setIsLoading(true);
      const newDate = new Date(date.getFullYear(), date.getMonth() + increment);
      setDate(newDate);
      ;
      try {
        const res = await getClubEventsFromClient(setIsLoading, token, newAbortController.signal, event.clubSlug, 1, newDate);
        const arrOfEvents = res.map(_temp2);
        setDisplayEventArr(arrOfEvents.map(_temp3));
        setEvents(res);
      } catch (t6) {
        const error = t6;
        console.error(error);
      }
    };
    $[7] = date;
    $[8] = event.clubSlug;
    $[9] = event.startDate;
    $[10] = setEvents;
    $[11] = token;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleMonthDate = t5;
  let t6;
  if ($[13] !== handleMonthDate) {
    t6 = () => {
      handleMonthDate(0);
    };
    $[13] = handleMonthDate;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const loadInitialMonth = useEffectEvent(t6);
  let t7;
  if ($[15] !== loadInitialMonth) {
    t7 = () => {
      loadInitialMonth();
    };
    $[15] = loadInitialMonth;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  useEffect(t7, t8);
  let t9;
  if ($[18] !== currentDate || $[19] !== date || $[20] !== displayEventArr || $[21] !== setIsHere || $[22] !== setValue) {
    t9 = index => {
      const indexof = displayEventArr.indexOf(currentDate);
      const newArray = displayEventArr.filter(date_1 => date_1 !== currentDate);
      if (newArray.includes(index)) {
        return;
      }
      newArray.splice(indexof + 1, 0, index);
      setDisplayEventArr(newArray);
      setCurrentDate(index);
      setValue("dayofmonth", new Date(date.setDate(index)).toLocaleDateString(undefined, {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
      }));
      setIsHere(false);
    };
    $[18] = currentDate;
    $[19] = date;
    $[20] = displayEventArr;
    $[21] = setIsHere;
    $[22] = setValue;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const handleEvent = t9;
  if (!isHere) {
    return null;
  }
  let t10;
  if ($[24] !== date) {
    t10 = getAllDaysOfMonth(date);
    $[24] = date;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== date || $[27] !== displayEventArr || $[28] !== eventArr || $[29] !== handleEvent || $[30] !== handleMonthDate || $[31] !== isLoading || $[32] !== t10) {
    t11 = <><DatePickerElement date={date} handleMonthDate={handleMonthDate} allDaysOfMonth={t10} isLoading={isLoading} eventArr={eventArr} handleEvent={handleEvent} displayEventArr={displayEventArr} /></>;
    $[26] = date;
    $[27] = displayEventArr;
    $[28] = eventArr;
    $[29] = handleEvent;
    $[30] = handleMonthDate;
    $[31] = isLoading;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
}
function _temp3(res_0) {
  return res_0.date.getDate();
}
function _temp2(elem) {
  return {
    id: elem["@id"],
    date: new Date(elem.startDate),
    cancel: elem.cancel
  };
}
function _temp(t0) {
  const {
    date: date_0
  } = t0;
  return new Date(date_0).getDate();
}
export default DatePicker;